import * as Session from '../api';

export const sendEmailOtpTwoFactorAuth = token => Session.sendOtpEmail(token);
export const verifyTwoFactorAuthentication = (token, otpCurrent) => Session.twoFAVerify(token, otpCurrent);
